export enum TemplateGalleryOptions {
  Preview = 'Preview',
  Send = 'Send',
  Copy = 'Copy',
  Use = 'Use',
}
